import { studentBookingClient } from '../client';

import { ProcessMicroPaymentDto } from './dto/ProcessMicroPayment.dto';
import { PaymentEndpoints } from './constants';
import { PaymentProcessResponse, PostPaymentProcessSuccessResponse } from './types';

export const postPaymentProcess = async (basket_id: string): Promise<PaymentProcessResponse> => {
    const { data: response } = await studentBookingClient.post<PostPaymentProcessSuccessResponse>(
        PaymentEndpoints.PostPaymentProcess,
        { basket_id }
    );

    return response.data;
};

export const postMicroPaymentProcess = async (
    payload: ProcessMicroPaymentDto
): Promise<PaymentProcessResponse> => {
    const { data: response } = await studentBookingClient.post<PostPaymentProcessSuccessResponse>(
        PaymentEndpoints.PostPaymentProcessMicroPayment,
        payload.serialisePayment()
    );

    return response.data;
};
